import { makeStyles } from "@material-ui/core/styles";

export function useUserAvatarStyles() {
  const useStyles = makeStyles((theme) => ({
    avatar: {
      height: 32,
      width: 32,
      backgroundColor: theme.palette.primary.main,
      marginRight: 10,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    textName: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: "bold",
      textTransform: "capitalize",
    },
    textCpf: {
      fontSize: theme.typography.pxToRem(10),
      fontWeight: 300,
      textAlign: "start",
    },
    menuItem: {
      minHeight: 42,
      color: "#737B7D",
      minWidth: 236,
    },
    textMenuItem: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: "normal",
      marginLeft: 10,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
